// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KYng-","colBig":"styles_colBig__2lpk5","colSmall":"styles_colSmall__3xte_","shopifyNameWrapper":"styles_shopifyNameWrapper__3LdQ2"};